{
  "aboutDeviceControls": "Informazioni sui controlli del dispositivo",
  "actionLabel": "Azione:",
  "adminUser": "Utente amministratore",
  "automation": "Automazione",
  "command": "Comando",
  "conditionLabel": "Condizione: ",
  "confirmDeviceActionCannotCancelWarning": "Questa azione non può essere annullata.",
  "confirmDeviceActionIAcceptText": "Accetto la responsabilità del risultato di questa azione",
  "confirmDeviceActionSuccessToast": "Richiesta inviata al dispositivo",
  "confirmDeviceActionSuccessToastWithDeviceName": "Richiesta inviata al dispositivo {{deviceName}}",
  "confirmDeviceActionWarningDescription": "Controllare manualmente un circuito può avere conseguenze pericolose. Eseguendo questa azione, accetti ogni responsabilità per qualsiasi danno o lesione che potrebbe derivarne.",
  "confirmationRequired": "Conferma richiesta",
  "controlPanelHelpContent": "Puoi inviare comandi per controllare direttamente l'interruttore (noto anche come relè) sul tuo dispositivo. Questi comandi possono avere effetti diversi in base al modo in cui hai installato il tuo dispositivo e al tipo di installazione della tua apparecchiatura.\n\nPer utilizzare questi controlli, devi avere l'autorizzazione per controllare i dispositivi da remoto. Se sei un responsabile della tua azienda agricola, puoi negare o concedere l'accesso a queste funzionalità dalle impostazioni dell'account.",
  "controls": "Controlli",
  "deviceActionHistoryListEmpty": "Nessuna cronologia dei comandi trovata per questo dispositivo",
  "deviceActionHistoryListTitle": "Cronologia delle azioni",
  "deviceActionHistoryListHelpBodyText": "Visualizza le azioni precedenti eseguite su un dispositivo. Questo elenco include le azioni automatizzate eseguite da FarmHQ, nonché le azioni manuali eseguite dagli utenti.",
  "deviceControls": "Controlli del dispositivo",
  "result": "Risultato",
  "system": "Sistema",
  "time": "Tempo",
  "triggeredBy": "Innescato da",
  "turnWaterOff": "Chiudere l'acqua",
  "turnWaterOn": "Accendi l'acqua",
  "unknownAction": "Azione sconosciuta",
  "warning": "Avvertimento"
}
